export default {
  title: 'Performanța campaniilor recente',
  recipients: '{{recipients}} Destinatari',
  error_messages: {
    failed_to_load_data: 'Eroare la încărcarea datelor',
  },
};
